import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import MoveIcon from "@common/images/move_icon.svg";

/**
 * SlideOneOption:
 *  - SlideOneOption Component in dropped state.
 */
export function SlideOneOption(props) {
  return (
    <div className="node-holder node-dropped">
      <div className="node-dropped__image">
        <Image src={MoveIcon} alt="move_icon" />
      </div>
      <div className="node-dropped__text">
        <p>{props.text}</p>
        {props.children}
      </div>
      <div className="node-dropped__feedback">{props.feedback}</div>
    </div>
  );
}

SlideOneOption.propTypes = {
  /**
   * Component to display the feedback for the option
   */
  feedback: PropTypes.element.isRequired,
  /**
   * Unique Id of the dropped option
   */
  id: PropTypes.number.isRequired,
  /**
   * Text to dispaled on the option
   */
  text: PropTypes.string.isRequired,
  /**
   * Operational components displayed on Option
   * Eg: RemoveOptionIcon
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

SlideOneOption.defaultProps = {
  text: "",
  groupColor: "#ffffff",
};
